import React from 'react';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';
import {
  NumberOfItemsInTable,
  NumberOfItemsInTableProps,
} from 'src/components/enterprise/Parents/NumberOfItemsInTable/NumberOfItemsInTable';

export type NumberOfParentAccountsProps = Omit<
  NumberOfItemsInTableProps,
  'suffix'
>;

export const NumberOfParentAccounts: React.FC<NumberOfParentAccountsProps> = ({
  totalResults,
  ...props
}) => {
  const noun = getSingularOrPlural(totalResults, 'account');

  const suffix = `parent ${noun}`;

  return (
    <NumberOfItemsInTable
      {...props}
      totalResults={totalResults}
      suffix={suffix}
    />
  );
};
